const Selectors = {
  feed: state => state.home.feed,
  loading: state => state.home.loading,
};

export default Selectors;
